/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_App_DescriptionInputs */

const en_admin_settings_fields_app_description = /** @type {(inputs: Admin_Settings_Fields_App_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App Description`)
};

const zh_admin_settings_fields_app_description = /** @type {(inputs: Admin_Settings_Fields_App_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`应用描述`)
};

/**
* | output |
* | --- |
* | "App Description" |
*
* @param {Admin_Settings_Fields_App_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_app_description = /** @type {((inputs?: Admin_Settings_Fields_App_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_App_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_fields_app_description(inputs)
	return zh_admin_settings_fields_app_description(inputs)
});
export { admin_settings_fields_app_description as "admin.settings.fields.app_description" }